module.exports = __webpack_public_path__ + "img/26_41.5bf0b13e.png";